module.exports = __webpack_public_path__ + "img/menu_expenses.07b051fe.svg";